module.exports = __webpack_public_path__ + "static/media/atc17_slides_son.5bf370f9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/atc17_slides_son.pdf
// module id = 62
// module chunks = 0